import React from 'react'
import Header from '../../HomePage/Header/Header'
import LoginContent from './LoginContent'
import Footer from '../../HomePage/Footer/Footer'
import FeedbackForm from '../../FeedbackForm/FeedbackForm'

const Login = () => {
  return (
    <div>
      <FeedbackForm />
      <Header />
      <LoginContent />
      <Footer />
    </div>
  )
}

export default Login